<template>
  <modal :visible="visible" @close="close" :title="title" transition="zoom">
    <div class="change-password-modal">
      <div class="columns is-vcentered centered">
        <div class="column is-6 is-offset-3">
          <div class="box">
            <div v-show="error" class="error-message" style="color:red; word-wrap:break-word;">{{ error }}<br><br></div>
            <form>
              <label class="label">Old Password</label>
              <p class="control">
                <input v-model="data.body.oldPassword" class="input" type="password">
              </p>
              <label class="label">New Password</label>
              <p class="control">
                <input v-model="data.body.newPassword" class="input" type="password">
              </p>
              <label class="label">Confirm New Password</label>
              <p class="control">
                <input v-model="confirmNewPassword" class="input" type="password">
              </p>
              <hr>
              <p class="control">
                <button @click="changePassword()" class="button is-primary">Change Password</button>
                <button @click="close()" class="button is-default">Cancel</button>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import UserResource from '../../resources/UserResource'

  export default {
    props: {
      visible: Boolean
    },

    data () {
      return {
        src: require('assets/logo.svg'),
        title: 'Change Password',
        confirmNewPassword: '',
        data: {
          body: {
            oldPassword: '',
            newPassword: ''
          }
        },
        error: null
      }
    },

    methods: {
      close () {
        this.$emit('close')
      },

      changePassword () {
        this.error = null
        let newPassword = this.data.body.newPassword
        if (newPassword !== this.confirmNewPassword) {
          this.error = "confirm password doesn't match"
        } else if (newPassword.length < 8) {
          this.error = 'password must contain at least 8 characters'
        } else {
          UserResource.changePassword(this.data.body)
            .then((data) => {
              if (data.error) {
                this.error = data.error
              } else {
                this.$toasted.show(`passwprd was changed`, {duration: 3000, type: 'info'})
                this.$emit('close')
              }
            })
        }
      }
    }
  }
</script>



<style lang="scss">

  .change-password-modal {
    .centered {
      margin: auto;
    }

    width: 100%;
    height: 500px;
  }

.is-title {
    text-transform: capitalize;
}
</style>
